import { ISgSdkHandler, TriggerAction } from "./types";

declare const sdkHandler: ISgSdkHandler; 

export default function triggerGameStart() {
  sdkHandler.trigger(TriggerAction.GAME_START);
}
